import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';

import actions from '../../../store/actions';
import { getLoginThunk } from '../../../store/thunks/auth';
import { authSelectors } from '../../../store/selectors/auth';

import LoadingBtn from '../../LoadingBtn/LoadingBtn';
import FieldPhone from '../../../common/Fields/FieldPhone';
import ErrorMessage from '../../../common/Errors/ErrorMessage';
import FieldPassword from '../../../common/Fields/FieldPassword';

import '../auth.scss';

const defaultFormFields = {
  phone: '',
  password: '',
};

const LoginForm = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const auth = useSelector(authSelectors);
  const token = auth.token;
  const user = auth.user;
  const error = auth.error;
  const status = auth.status;
  const load = auth.load;

  const [formFields, setFormFields] = useState(defaultFormFields);
  const [phone, setPhone] = useState();

  const { password } = formFields;
  const from = location.state?.from?.pathname || '/';

  useEffect(() => {
    if (token && status === 1) {
      logIn(user);
      resetFormFields();
      navigate(from, { replace: true });
      resetErrors();
    } else {
      navigate('/login', { replace: true });
      resetErrors();
    }
  }, [token, user]);

  const resetFormFields = () => {
    setFormFields(defaultFormFields);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };

  const logIn = data => {
    const now = new Date();
    const item = {
      name: 'user_token',
      value: data.token,
      expiry: now.getTime() + 1000 * 60 * 60 * 2, // 2 hrs
    };
    localStorage.setItem('user_token', JSON.stringify(item));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const dataAuth = {
      phone: `+${phone}`,
      password: password,
    };
    resetErrors();
    dispatch(getLoginThunk(dataAuth));
  };

  const resetErrors = () => {
    dispatch(actions.auth.setLoginError(''));
    dispatch(actions.auth.setLoginErrors({}));
  };

  return (
    <form onSubmit={handleSubmit} className="auth__form form">
      <FieldPhone
        name="phone"
        type="tel"
        valuePhone={phone}
        onChange={setPhone}
        labelText="Телефон"
        labelMessage=""
        formClass="required"
        required
      />

      <FieldPassword
        name="password"
        value={password}
        onChange={handleChange}
        labelText="Пароль"
        formClass="form__field required"
        required
      />

      {/*
        Єдиний рядок помилки (in-flow ErrorMessage): показує auth.error
        (info.message із 422 = перша помилка валідації, або текст 500).
        Раніше поряд рендерився ще ErrorField (position: absolute) з тим
        самим текстом — вони накладались один на одного. Лишаємо один.
      */}
      {error && <ErrorMessage errorText={error} />}

      <div className="auth__btns">
        <LoadingBtn btnText='Увійти' load={load} />
        <div className="auth__text">
          <a
            href="https://telegram.me/newbraincomua_bot?start=_registerCabinet"
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            Зареєструватись
          </a>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
